<template>
    <div style="margin-top: 10px; margin-left: 30px;">
        <el-card shadow="hover" class="document-card">
            <el-row :gutter="20">
                <el-col :span="7">
                    <el-button type="primary">价值评估</el-button>
                </el-col>
            </el-row>

            <el-row :gutter="20" type="flex" justify="end" style="margin-bottom: 20px;">
                <el-col :span="14">
                    <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
                        <el-select v-model="authState" placeholder="评估状态" style="width: 125px;"
                            @change="handleFilterChange">
                            <el-option label="全部" value="全部"></el-option>
                            <el-option label="待评估" value="待评估"></el-option>
                            <el-option label="评估中" value="评估中"></el-option>
                            <el-option label="评估完成" value="评估完成"></el-option>
                        </el-select>
                        <el-input v-model="assetName" placeholder="请输入资产名称..." style="width: 350px;"
                            @keydown.enter.native="doSearch" clearable>
                            <el-button slot="append" icon="el-icon-search" @click="doSearch"
                                style="background-color: #1E88E5; color: white;">搜索</el-button>
                        </el-input>
                    </div>
                </el-col>
            </el-row>

            <div class="table" style="margin-top: 20px; width: 100%">
                <el-table :data="tableData" border style="width: 100%"
                    :header-cell-style="{ background: '#f5f5f5' }">
                    <el-table-column type="index" label="序号" width="60" fixed="left" align="center">
                    </el-table-column>
                    <el-table-column prop="registrationId" label="资产登记编号" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="assetName" label="资产登记名称" min-width="220" align="center">
                    </el-table-column>
                    <el-table-column prop="dataSource" label="数据来源" min-width="80" align="center">
                    </el-table-column>
                    <el-table-column prop="industry" label="所属行业" min-width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="state" label="评估状态" min-width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="!scope.row.state" type="info" size="small">待申请</el-tag>
                            <el-tag v-else-if="scope.row.state === '待评估'" type="warning" size="small">待评估</el-tag>
                            <el-tag v-else-if="scope.row.state === '评估中'" type="warning" size="small">评估中</el-tag>
                            <el-tag v-else-if="scope.row.state === '评估完成'" type="success" size="small">评估完成</el-tag>
                            <el-tag v-else type="info" size="small">{{ scope.row.state }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="valueAssessmentReport" label="评估报告" min-width="200" align="center">
                        <template slot-scope="scope">
                            <el-link v-if="scope.row.valueAssessmentReport" type="primary"
                                @click="downloadReport(scope.row)">
                                {{ scope.row.valueAssessmentReport }}
                            </el-link>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="160" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="!scope.row.state || scope.row.state === '待申请'" size="mini"
                                type="success" @click="handleApply(scope.row)">
                                提交申请
                            </el-button>
                            <el-button v-if="scope.row.state === '待评估' || scope.row.state === '评估中'" size="mini"
                                type="info" disabled>
                                等待评估
                            </el-button>
                            <el-button v-if="scope.row.state === '评估完成'" size="mini"
                                type="primary" @click="handleView(scope.row)">
                                查看详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-card>

        <div class="block" style="display: flex; justify-content: center; margin-top: 20px">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="boardsTotal"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange" :pager-count="5"
                :background="true">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DataValueManage',
    data() {
        return {
            boardsTotal: 0,
            currPage: 1,
            pageSize: 10,
            assetName: '',
            tableData: [],
            authState: '全部'
        }
    },
    mounted() {
        this.initTableData();
    },
    methods: {
        handleCurrentChange(val) {
            this.currPage = val;
            this.initTableData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.initTableData();
        },
        initTableData() {
            const user = JSON.parse(window.localStorage.getItem('user'));
            this.$axios.get('/web/dataValue/queryListByUserId', {
                params: {
                    assetName: this.assetName,
                    state: this.authState,
                    currPage: this.currPage,
                    pageSize: this.pageSize
                },
                headers: { 'X-User-Id': user.id }
            }).then(resp => {
                if (resp && resp.data) {
                    this.boardsTotal = resp.data.total;
                    this.tableData = resp.data.list;
                }
            }).catch(err => {
                console.error('请求失败:', err);
            });
        },
        doSearch() {
            this.currPage = 1;
            this.initTableData();
        },
        handleFilterChange() {
            this.currPage = 1;
            this.initTableData();
        },
        handleApply(row) {
            const user = JSON.parse(window.localStorage.getItem('user'));
            this.$router.push({
                path: '/DataValueApply',
                query: { registrationId: row.registrationId, userId: user.id }
            });
        },
        handleView(row) {
            this.$router.push({
                path: '/DataValueDetail',
                query: { registrationId: row.registrationId }
            });
        },
        async downloadReport(row) {
            try {
                const response = await this.$axios({
                    method: 'get',
                    url: '/web/dataValue/download',
                    params: { registrationId: row.registrationId, fileName: row.valueAssessmentReport },
                    responseType: 'blob'
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', row.valueAssessmentReport);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } catch (error) {
                this.$message.error('文件下载失败: ' + error.message);
            }
        }
    }
}
</script>

<style scoped>
.el-button--mini {
    min-width: 60px;
    height: 28px;
}

.document-card>>>el-table__header th {
    text-align: center;
    font-size: 14px;
}

.el-pagination.is-background {
    padding: 15px 0;
}
</style>
